import { render } from "./Foerderdokument.pug?vue&type=template&id=cd3c6b0e&lang=pug"
import script from "./Foerderdokument.js?vue&type=script&lang=js"
export * from "./Foerderdokument.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__